import { combineReducers } from "redux";
import accrualCalculatorHistory from "./AccrualCalculatorHistory";
import activeApis from "./ActiveApisReducer";
import activeConsultants from "./ActiveConsultantListReducer";
import availableHours from "./AvailableHoursReducer";
import availableHoursHistory from "./AvailableHoursHistoryReducer";
import availableHoursNotes from "./AvailableHoursNotesReducer";
import blackoutPeriod from "./BlackoutPeriodReducer";
import calculableAccrualQuarters from "./CalculableAccrualQuarters";
import consultants from "./ConsultantsReducer";
import eligableHours from "./EligableHoursReducer";
import FaQs from "./FaQReducer";
import hourUtilizationRequests from "./HourUtilizationRequestReducer";
import hoursTransationTypes from "./HoursTransactionTypesReducer";
import profile from "./ProfileReducer";
import today from "./DateReducer";
import utilization from "./UtilizationReducer";
import utilizatioRequestStatus from "./UtilizationRequestStatusReducer";
import ptoDetails from "./PtoDetailsReducer";
import presClubDetails from "./PresClubReducer";
import presClubAdminDetails from "./PresClubReducer";
import impersonationReducer from './ImpersonationReducer';

const rootReducer = combineReducers({
  accrualCalculatorHistory,
  activeApis,
  activeConsultants,
  availableHours,
  availableHoursHistory,
  availableHoursNotes,
  blackoutPeriod,
  calculableAccrualQuarters,
  consultants,
  eligableHours,
  FaQs,
  hourUtilizationRequests,
  hoursTransationTypes,
  profile,
  today,
  utilization,
  utilizatioRequestStatus,
  ptoDetails,
  presClubDetails,
  presClubAdminDetails,
  impersonationReducer
});

export default rootReducer;
